import { Box, Typography, ButtonBase } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import Header from '../../components/Header';
import { useTranslation } from '../../hooks/useTranslation';
import { DataContext } from '../../contexts/DataContext';
import PrimaryButton from '../../components/PrimaryButton';
import FloatingActions from '../../components/FloatingActions';
import { useTranslation as orginalUsetranslation } from 'react-i18next';
import CouponPage from './CouponPage';

function DevicesPage() {
  const { t } = useTranslation();
  const {t:toriginal}=orginalUsetranslation()
  const { steps, currentStep, data, setCurrentStep, setData, trackEvent ,flowNumber} =
    useContext(DataContext);
  const onSubmit = () => {
    console.log('data in devices page', data);
    if(flowNumber === 1 &&
      !data?.isReturning &&
      data?.storeHasCouponlogic && data?.country?.includes('lux') ) {
      setCouponPage(true);
    } else {
      setCurrentStep(currentStep + 1);
    }
    //
    
  };
  useEffect(() => {
    trackEvent({ nav_to_your_devices: 1 });
  }, [trackEvent]);
    const [couponPage, setCouponPage] = useState(false);
  

      if (couponPage) return <CouponPage onFinish={()=>setCurrentStep(currentStep + 1)} />;


  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
      }}
    >
      <Header steps={steps} currentStep={currentStep} />
      
     
          <div
        style={{
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'column',
          paddingInline: '24px',
          alignItems: 'stretch',
          textAlign: 'left',
        }}
      >
        <Typography
          sx={{
            fontSize: '32px',
            fontWeight: '700',
            lineHeight: '38.46px',
          }}
        >
          {t('devicesPage.title')}
        </Typography>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: '500',
            marginTop: '5px',
          }}
        >
          {t('devicesPage.description')}
        </Typography>
        <div
          style={{
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'flex-start',
            gap: '16px',
            marginTop: '24px',
          }}
        >
          {[...data?.devices].map((x, i) => (
            <div
              key={i}
              style={{
                background: 'white',
                display: 'flex',
                flexDirection: 'row',
                borderRadius: '4px',
                gap: '15px',
                height: x?.src?.length > 12 ? '68px' : '',
                padding: '12px',
              }}
            >
              {x?.src?.length > 12 && (
                <div
                  style={{
                    width: '68px',
                    height: '68px',
                    background: '#D9D9D9',
                    borderRadius: '2px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={x?.src}
                    alt={x?.code}
                    style={{
                      maxWidth: '68px',
                      width: '68px',
                      borderRadius: '2px',
                      objectFit: 'contain',
                    }}
                  />
                </div>
              )}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  gap: '7px',
                  alignItems: 'flex-start',
                }}
              >
                {i === data?.devices?.length - 1 && (
                  <div
                    style={{
                      borderRadius: '6px',
                      background: 'rgba(0, 209, 210, 0.10)',
                      padding: '4px',
                      width: '',
                      height: '18px',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="8"
                        viewBox="0 0 10 8"
                        fill="none"
                      >
                        <path
                          d="M1.25 4L3.75 6.5L8.75 1.5"
                          stroke="#00D1D2"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        lineHeight: '18px',
                        color: '#00D1D2',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {t('devicesPage.justAdded')}
                    </Typography>
                  </div>
                )}
                <Typography
                  sx={{
                    fontSize: '17px',
                    fontWeight: '700',
                    lineHeight: '21px',
                  }}
                >
                  {x?.code?.match(/.{1,3}/g)?.join(' ') || ''}
                </Typography>
              </div>
            </div>
          ))}
          
        </div>
         
        
      </div>
    
      <FloatingActions childrenStyle={{}}>
        
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'space-between',
            gap: '16px',
            paddingInline: '24px',
          }}
        ><ButtonBase
          onClick={() => {
            trackEvent({ nav_to_another_code: 1 });

            setData({
              ...data,
              code: '',
              file: '',
              submitted: false,
              byPicture: false,
              byCode: false,
              errors: {
                ...data?.errors,
                file: false,
                code: false,
              },
            });
            setCurrentStep(currentStep - 1);
          }}
          style={{
            marginTop: '16px',
            height: '40px',
            borderRadius: '6px',
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
            alignItems: 'center',
            paddingInline: '8px',
            background: 'rgba(0, 209, 210, 0.10)',
          }}
        >
          <div style={{ height: '26.5px', width: '26.5px' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27"
              height="28"
              viewBox="0 0 27 28"
              fill="none"
            >
              <path
                d="M13.25 27.25C10.6294 27.25 8.06765 26.4729 5.8887 25.017C3.70975 23.561 2.01146 21.4917 1.0086 19.0706C0.00574088 16.6494 -0.256653 13.9853 0.254601 11.4151C0.765855 8.84481 2.02779 6.48388 3.88084 4.63084C5.73388 2.77779 8.09481 1.51585 10.6651 1.0046C13.2353 0.493347 15.8994 0.755741 18.3206 1.7586C20.7417 2.76146 22.811 4.45975 24.267 6.6387C25.7229 8.81765 26.5 11.3794 26.5 14C26.4971 17.5132 25.1001 20.8817 22.6159 23.3659C20.1317 25.8501 16.7632 27.2471 13.25 27.25ZM13.25 2.59884C10.9951 2.59884 8.79077 3.26751 6.91586 4.52028C5.04095 5.77306 3.57963 7.55368 2.7167 9.63697C1.85378 11.7203 1.628 14.0126 2.06791 16.2243C2.50783 18.4359 3.59368 20.4674 5.18816 22.0618C6.78265 23.6563 8.81414 24.7422 11.0257 25.1821C13.2374 25.622 15.5297 25.3962 17.613 24.5333C19.6963 23.6704 21.4769 22.2091 22.7297 20.3341C23.9825 18.4592 24.6512 16.2549 24.6512 14C24.6476 10.9773 23.4452 8.07948 21.3079 5.94213C19.1705 3.80477 16.2727 2.60243 13.25 2.59884Z"
                fill="#00D1D2"
              />
              <path
                d="M13.25 2.59884C10.9951 2.59884 8.79077 3.26751 6.91586 4.52028C5.04095 5.77306 3.57963 7.55368 2.7167 9.63697C1.85378 11.7203 1.628 14.0126 2.06791 16.2243C2.50783 18.4359 3.59368 20.4674 5.18816 22.0618C6.78265 23.6563 8.81414 24.7422 11.0257 25.1821C13.2374 25.622 15.5297 25.3962 17.613 24.5333C19.6963 23.6704 21.4769 22.2091 22.7297 20.3341C23.9825 18.4592 24.6512 16.2549 24.6512 14C24.6476 10.9773 23.4452 8.07948 21.3079 5.94213C19.1705 3.80477 16.2727 2.60243 13.25 2.59884Z"
                fill="#00D1D2"
              />
              <path
                d="M16.2498 13.9998H10.2502"
                stroke="white"
                stroke-width="1.84884"
                stroke-linecap="round"
              />
              <path
                d="M13.2499 11.0001V16.9998"
                stroke="white"
                stroke-width="1.84884"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <Typography
            sx={{ fontSize: '16px', fontWeight: '700', lineHeight: '19.76px' }}
          >
            {t('devicesPage.addanotherdevice')}
          </Typography>
        </ButtonBase>
          <PrimaryButton style={{ flex: 1 }} onClick={onSubmit}>
            {t('continue')}
          </PrimaryButton>
        </div>
      </FloatingActions>
    </Box>
  );
}

export default DevicesPage;
